import { Button } from '@material-ui/core';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import ExcelIcon from '../../layout/icons/ExcelIcon';
import LoadingIndicator from '../../layout/loading/LoadingIndicator';
import Tooltip from '../../layout/Tooltip';
import useExportAppointmentToExcel from './useExportAppointmentToExcel';

const maximumNumberOfItemsToExport = process.env.REACT_APP_MAX_EXCEL_ENTRIES_TO_EXPORT;

const AppointmentListActions = ({ totalCount }) => {
  const [exportToExcel, isGeneratingExcel] = useExportAppointmentToExcel();
  const { t } = useTranslation('appointment');
  const { search } = useLocation();

  const handleExportToExcelClick = useCallback(() => {
    const parameters = new URLSearchParams(search);
    exportToExcel(parameters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [exportToExcel, search, t]);

  const getTooltip = useCallback(() => {
    if (totalCount > maximumNumberOfItemsToExport) return t('tooManyResultsMessage', { number: process.env.REACT_APP_MAX_EXCEL_ENTRIES_TO_EXPORT });
    if (!totalCount) return t('noResultToExportMessage');
    return '';
  }, [t, totalCount]);

  const excelButtonDisabled = !totalCount || isGeneratingExcel || totalCount > maximumNumberOfItemsToExport;

  return (
    <>
      <LoadingIndicator show={isGeneratingExcel} />
      <Tooltip arrow spanStyle={{ cursor: 'not-allowed' }} title={getTooltip()} placement="top">
        <Button
          disabled={excelButtonDisabled}
          onClick={handleExportToExcelClick}
          color="primary"
          variant="text"
          size="small"
          startIcon={<ExcelIcon disabled={excelButtonDisabled} />}>
          {t('exportToExcel')}
        </Button>
      </Tooltip>
    </>
  );
};

AppointmentListActions.propTypes = {
  totalCount: PropTypes.number,
};

AppointmentListActions.defaultProps = {
  totalCount: 0,
};

export default AppointmentListActions;
